module.exports = __webpack_public_path__ + "static/5-e4dd0ca2ab98e87eacad87e391414b51.png";